import { useEffect, useState } from "react";
import styled from "styled-components";
import LessonSelect from "../Form/LessonSelect";
import patch from "../../axe-api/patch";

const BoxContainer = styled.div`
  width: calc(100% - 50px);
  padding: 20px;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
`;

const BoxTitle = styled.div`
  font-weight: bold;
  border: 1px solid rgb(95, 95, 207);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin: -20px -20px 20px -20px;
  padding: 10px 20px;
  text-align: center;
`;

const OPTIONS = ["A", "B", "C", "D", "E"];

const OptionRow = styled.div`
  display: flex;
  gap: 4px;
  padding-bottom: 10px;
  justify-content: center;
`;

const OptionCircle = styled.div`
  background-color: ${({ isMarked }) => (isMarked ? "#f77979" : "white")};
  border: 1px solid #ffdede;
  color: ${({ isMarked }) => (isMarked ? "white" : "#999")};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;

const OptionCount = styled(OptionCircle)`
  background-color: #999;
  border: 1px solid #888;
  color: white;
`;

export default function AnswerBox({
  index,
  exam,
  items,
  refetch,
  isEditable = true,
}) {
  const currentValue = exam[`box${index}`];
  const [defaultValue, setDefaultValue] = useState(false);

  const handleChange = async ({ value }) => {
    await patch(`group-exams/${exam.id}`, {
      [`box_${index}`]: value,
    });
    await refetch();
  };

  useEffect(() => {
    setDefaultValue(false);
    const timeout = setTimeout(() => {
      setDefaultValue(currentValue);
      clearTimeout(timeout);
    }, 100);
  }, [currentValue]);

  return (
    <BoxContainer>
      <BoxTitle>
        {isEditable && defaultValue !== false && (
          <LessonSelect
            name="lesson_id"
            title="Ders"
            isCreatable={true}
            onChange={handleChange}
            defaultValue={defaultValue}
          />
        )}
        {!isEditable && currentValue.name}
      </BoxTitle>
      {items.map((value, index) => (
        <OptionRow key={index}>
          <OptionCount>{index + 1}</OptionCount>
          {OPTIONS.map((option) => (
            <OptionCircle key={option} isMarked={value === option}>
              {option}
            </OptionCircle>
          ))}
        </OptionRow>
      ))}
    </BoxContainer>
  );
}
